import { render } from "./AnimatedIcon.vue?vue&type=template&id=0b229d75&scoped=true"
import script from "./AnimatedIcon.vue?vue&type=script&lang=js"
export * from "./AnimatedIcon.vue?vue&type=script&lang=js"

import "./AnimatedIcon.vue?vue&type=style&index=0&id=0b229d75&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b229d75"]])

export default __exports__